import type { Log } from '@timeedit/calendar-integration-api-contract';
import { Col, Row, Typography } from '@timeedit/ui-components/antd';
import './LogDetails.scss';

export const LogDetails = ({ logEntry }: { logEntry: Log }) => {
  return (
    <div className="log-details--wrapper">
      {logEntry.context?.map(({ key, value }) => {
        return (
          <Row key={key}>
            <Col span={3}>
              <Typography.Text>{String(key)}</Typography.Text>
            </Col>
            <Col span={21}>
              {['string', 'number'].includes(typeof value) ? (
                <Typography.Text strong>{String(value)}</Typography.Text>
              ) : (
                <Typography.Text strong style={{ whiteSpace: 'pre-wrap' }}>
                  {JSON.stringify(value, null, 4)}
                </Typography.Text>
              )}
            </Col>
          </Row>
        );
      })}
    </div>
  );
};
